import { InputType } from 'config'

export const defaultInputs = (): Record<string, InputType> => {
  return {
    title: {
      inputType: 'text',
      title: 'Title',
      required: true,
    },
    days: {
      inputType: 'text',
      type: 'number',
      title: 'Days',
      required: true,
    },
    isOnlyExpiredDate: {
      inputType: 'togglebutton',
      title: 'Is Only Expired Date?',
      required: true,
    },
    calculateBasedOn: {
      inputType: 'select',
      title: 'Calculate based on',
      options: {
        1: 'Today Date',
        2: 'Closing Date',
      },
    },
    isSeasoning: {
      inputType: 'togglebutton',
      title: 'Is Seasoning?',
      required: true,
    },
    // isCoBorrower: {
    //   inputType: 'togglebutton',
    //   title: 'Is Coborrower?',
    //   required: true,
    // },
  }
}
